import React from 'react';
import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom';
import { Button, Alert } from 'react-bootstrap';

export default function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  let errorMessage = 'An unexpected error occurred';
  let errorStatus = 500;

  if (isRouteErrorResponse(error)) {
    errorMessage = error.data || error.statusText;
    errorStatus = error.status;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '50vh' }}>
      <Alert variant="danger" className="w-75">
        <Alert.Heading>Error {errorStatus}</Alert.Heading>
        <p>{errorMessage}</p>
        <hr />
        <div className="d-flex justify-content-end">
          <Button variant="outline-danger" onClick={handleGoBack}>
            Go Back
          </Button>
        </div>
      </Alert>
    </div>
  );
} 